import { createApp } from 'vue';
import { installStore } from '@/pinia/index';
import { registerGlobComp } from '@/components/Base/installBaseComp';
import router, { installRouter } from './router';
import App from './App.vue';
import '@/authority';
import '@/style/index.scss';
import 'lib-flexible/flexible';
import { useEnv } from './hooks/useEnv';
import { useWxConfig } from './hooks/useWx';
import { installAuth } from '@/authority';
const { initWxConfig } = useWxConfig();

function initApp() {
  const app = createApp(App);
  // 全局组件
  registerGlobComp(app);
  // 注册store
  installStore(app);
  // 注册路由
  installRouter(app);

  installAuth(router);

  app.mount('#app');

  useEnv();

  initWxConfig();
}

initApp();
